import React from 'react';
import createChainedFunction from 'utils/createChainedFunction';
import pickInputElementProps from 'utils/pickInputElementProps';

const AutosizeInput = React.createClass({
  propTypes: {
    placeholder: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      placeholder: '',
    };
  },

  getInitialState() {
    return { size: this.props.placeholder.length + 1 };
  },

  componentWillReceiveProps(newProps) {
    if (this.props.placeholder !== newProps.placeholder) {
      this.setState({ size: newProps.placeholder.length + 1 });
    }
  },

  onChange() {
    const value = this.refs.input.value;
    if (value.length === 0) {
      this.setState(this.getInitialState());
    } else {
      this.setState({ size: value.length + 1 });
    }
  },

  render() {
    const { onChange, ...others } = this.props;
    const props = pickInputElementProps(others);

    return (
      <input
        ref="input"
        {...props}
        size={this.state.size}
        onChange={
          createChainedFunction(
            this.onChange,
            onChange
          )
        }
      />
    );
  },
});

export default AutosizeInput;



// WEBPACK FOOTER //
// ./src/components/AutosizeInput.jsx